let _authors = [
  {
    name: "Albert Einstein",
    image: "albert_einstein.jpg",
    line:
      "I got the Nobel Prize for discovering the photoelectric effect and I told everyone that God does not play dice."
  },
  {
    name: "Alfred Russel Wallace",
    image: "alfred.png",
    line:
      "I am the father of biogeography, have you read my book The Revolt of Democracy ?"
  },
  {
    name: "Charles Darwin",
    image: "charles_darwin.jpg",
    line:
      "I told the world that it is not the strongest of the species that survive, nor the most intelligent, but the one most responsive to change."
  },
  {
    name: "Augustin-Louis Cauchy",
    image: "augustin_louis_cauchy.jpg",
    line:
      "I am a french mathematician and was well appreciated for my single-handed development of complex function theory."
  },
  {
    name: "Charles Lyell",
    image: "charles_lyell.jpg",
    line:
      "I am a famous 19th century British geologist and was a proponent of a theory that is now known as uniformitarianism."
  },
  {
    name: "Erwin Schrodinger",
    image: "erwin.jpg",
    line:
      "I derived the first wave equation in quantum mechanics and showed that a cat inside a closed box can be both dead and alive."
  },
  {
    name: "Joseph Fourier",
    image: "fourier.jpg",
    line:
      "I showed how a function can be represented as a sum of sine waves and also did extensive work on heat transfer problems."
  },
  {
    name: "Carl Friedrich Gauss",
    image: "gauss.jpg",
    line: "Have you ever used the normal distribution? Thank me for that"
  },
  {
    name: "Georges Cuvier",
    image: "georges_cuvier.jpg",
    line: "I am the father of paleontology and the dinosaurs are my favourite"
  },
  {
    name: "Jean-Baptiste Lamarck",
    image: "jean_baptiste_de_lamarck.jpg",
    line:
      "I was responsible for the theory of adaption which is also known as inheritance of acquired characteristics"
  },
  {
    name: "Issac Newton",
    image: "isaac_newton.jpg",
    line:
      "I saw the apple fall from the tree and invented the laws of gravitation"
  },
  {
    name: "Simon Laplace",
    image: "laplace.jpg",
    line:
      "I served as the count of the French empire, called as Newton of France and discovered an important integral transform."
  },
  {
    name: "Wilhelm Leibniz",
    image: "leibniz.jpg",
    line:
      "Once I was trying to find the area under the graph of a curve y=f(x) and discovered Integral Calculus"
  },
  {
    name: "Leonhard Euler",
    image: "leonhard_euler.jpg",
    line:
      "For the sake of brevity we will always consider this number 2.718281828.. as e, which I invented."
  },
  {
    name: "Thomas Malthus",
    image: "malthus.jpg",
    line:
      "The power of population is indefinitely greater than the power in the earth to produce subsistence for man"
  },
  {
    name: "Marie Curie",
    image: "marie_curie.jpg",
    line:
      "I am the first person to win two Nobel Prizes, one in physics and the other in chemistry"
  },
  {
    name: "Neils Bohr",
    image: "neil_bohr.png",
    line:
      "I am Danish and I am the first person to see the inside of an atom in the first half of the twentieth century."
  },
  {
    name: "Srinivasa Ramanujan",
    image: "ramanujan.jpg",
    line:
      "I am a famous mathematician, who died young and whose work on modular functions is revolutionising String Theory"
  },
  {
    name: "Rene Descartes",
    image: "rene_descartes.jpg",
    line:
      "I am the father of Analytic Geometry and the famous saying 'Cogito Ergo Sum' is attributed to me."
  },
  {
    name: "Stephen Hawking",
    image: "stephen_hawking.jpg",
    line:
      "I am considered to be the smartest physicist alive, my best friend is Time and I love Black Holes"
  },
  {
    name: "Alfred Werner",
    image: "werner.jpg",
    line: "I was the first to win Nobel Prize for Inorganic chemistry"
  }
];

var $ = (window.jQuery = require("jquery"));
import game_header from "../../components/game-header/index.vue";
import appFooter from '../../components/footer/index';
var lives = 3;
var level = 1;
let authorsObj = [];
let tempAuthorsObj = [];
let author = null;
let saying = null;
let points = null;
let lifes = null;
let randomAuthorObj = null;
let line = null;
const ammount = 40;

let seconds = 0;
let minutes = 0;

let interval = null;

let clockType = undefined;

let hasStarted = false;
let hasEnded = false;

export default {
  name: "eureka",
  components: {
    "game-header": game_header,
    "app-footer": appFooter,
  },
  props: [],
  data: function () {
    return {
        count: 0
      }
  },
  computed: {},

  mounted() {
    window.addEventListener("load", () => {
      $(".loader-wrapper").fadeOut();
      let hash = this.$route.hash;
      let element = document.getElementById('game');
      if (hash && hash == '#game') {
        element.scrollIntoView({ behavior: 'smooth'});;
      }
    });
    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(".black-box, .game-buttons, #start").length) {
        $(".black-box").fadeOut(1000);
        setTimeout(function(){
        $(".heading").removeClass('active_heading');
        $('.stg_png').addClass('col-md-6').removeClass('col-md-12 active')
        $(".game-buttons").show();
        $(".button-col")
          .addClass("col-md-6")
          .removeClass("col-md-12")
          .removeClass("button-col-down");
        $(".button-row").removeClass("move-down-start");
        $("#start").css("bottom", "0px");
        $("#first-page").fadeIn();
        $('#go-next-page').fadeIn();
        $("#second-page").hide();
        }, 1000)
      }
    });
  },
  methods: {
    pad: function(d) {
      return (d < 10) ? '0' + d.toString() : d.toString()
    },
    startClock: function() {
        hasStarted = false
        hasEnded = false

        seconds = 0
        minutes = 0

        if (ammount > 3599) {
          let hou = Math.floor(ammount / 3600)
          let min = Math.floor((ammount - (hou * 3600)) / 60)
          minutes = min;
          let sec = (ammount - (hou * 3600)) - (min * 60)
          seconds = sec
        }
        else if (ammount > 59) {
          let min = Math.floor(ammount / 60)
          minutes = min
          let sec = ammount - (min * 60)
          seconds = sec
        }
        else {
            seconds = ammount
        }

        if (seconds <= 10 && clockType === 'countdown' && minutes === 0) {
            $('#timer').find('span').addClass('blink_me')
        }

        this.refreshClock();

        $('.input-wrapper').slideUp(350)
        setTimeout(function () {
            $('#timer').fadeIn(350)
            $('#stop-timer').fadeIn(350)

        }, 350)

        this.countdown()

    },
    restartClock: function() {
        this.clear(interval);
        hasStarted = false
        hasEnded = false

        seconds = 0
        minutes = 0

        $('#timer').find('.seconds').text('00')
        $('#timer').find('.minutes').text('00')

        $('#timer').find('span').removeClass('blink_me')

        $('#stop-timer').fadeOut(100)
        $('button#resume-timer').fadeOut(100)
        $('button#reset-timer').fadeOut(100)
    },
    pauseClock: function() {
        this.clear(interval);
        $('#resume-timer').fadeIn()
        $('#reset-timer').fadeIn()
    },
    countdown: function() {
        hasStarted = true
        interval = setInterval(() => {
            if (hasEnded === false) {
                if (seconds <= 11 && minutes === 0) {
                    $('#timer').find('span').addClass('blink_me')
                }

                if (seconds > 0) {
                    seconds--
                    this.refreshClock();
                }
                else if (seconds === 0) {
                    this.refreshClock();
                }
            }
            else {
                this.restartClock()
            }

        }, 1000)
    },
    refreshClock: function() {
        $('#timer').find('.seconds').text(this.pad(seconds))
        $('#timer').find('.minutes').text(this.pad(minutes))


        if (minutes === 0 && seconds === 0 && hasStarted === true) {
            hasEnded = true
            this.pauseClock();
            $(".black-game-box").fadeOut();
            points = (level - 1) * 20;
            $(".load-points").text(points);
            $("#out_of_lives h1").html(
                'yikes <span class="exclaim">!</span> you have run out of time <span class="exclaim">!</span>'
            );
            $("#out_of_lives").fadeIn();
        }
    },
    clear: function(intervalID) {
        clearInterval(intervalID)
    },
    getHowTo: function() {
      // $(".heading").css("top", "40px");
      $(".heading").addClass('active_heading');
      $('.stg_png').removeClass('col-md-6').addClass('col-md-12 active')
      $(".game-buttons").hide();
      $(".button-col")
        .removeClass("col-md-6")
        .addClass("col-md-12")
        .addClass("button-col-down");
      $(".button-row").addClass("move-down-start");
      $("#start").css("bottom", "20px");
      $("#start").fadeIn(1000);
        $(".black-box").fadeIn(1000);
    },
    goToNextPage: function() {
      $("#go-next-page").click(function() {
        $("#first-page").hide();
        $("#second-page").fadeIn();
        $(this).hide();
      });
    },
    generateUniqueArr: function() {
      let arr = [];
      while(arr.length < 4){
          let r = Math.floor(Math.random() * _authors.length);
          if(arr.indexOf(r) === -1) arr.push(r);
      }
      return arr;
    },
    getAuthorObj() {
      return this.generateUniqueArr().map(i => {
        return _authors[i];
      });
    },
    shuffle: function(array) {
      var currentIndex = array.length, temporaryValue, randomIndex;
    
      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
    
      return array;
    },
    startGame: function() {
      $(".starting-screen").fadeOut(1000);
      $(".load-persons").html("");
      $("#m-loader").show();
      $(".next-lvl-btn").fadeOut();
      setTimeout(function() {
        $(".main-game").fadeIn();
        $(".heading").removeClass('active_heading');
      }, 1000);
      tempAuthorsObj = this.getAuthorObj();
      authorsObj = this.shuffle(tempAuthorsObj)
      let tempRandomNum = Math.floor(Math.random() * 4);
      randomAuthorObj = authorsObj[tempRandomNum];
      line = randomAuthorObj.line;

      var persons = authorsObj;
      var length = persons.length;

      $(".load-persons").html("");

      for (var i = 0; i < length; i++) {
        let childEle = `
					<div class='col-md-3 s-box img_block_wrapper'>
						<div class='img_block ${persons[i].image.split(".")[0]}'>${
          persons[i].name
        }</div>
						<div class='s-name authorName'>${persons[i].name}</div>
					</div>
				`;
        $(".load-persons").append(childEle);
      }

      $(".one-liner").html('"<span id="load-line"></span>"');
      $("#load-line").text(line);
      $("#m-loader").hide();
      this.startClock();
    },
    endGame: function() {
      this.pauseClock();
      points = (level - 1) * 20;
      $(".con-text").html(
        "<h1>thanks for playing</h1><span class='modal-txt'><br><br>You now have a total of " +
          points +
          " Points!</span>"
      );
      $(".black-game-box").fadeOut();
      $("#congrats").fadeIn();
    },
    playAgain: function() {
      window.location.reload();
    },
    imgCLickChk: function(event) {
      author = event.target.innerText;
      saying = $("#load-line").text();

      let data = authorsObj;
      $(".loader-wrapper2").fadeIn();
      for (let index = 0; index < data.length; index++) {
        if (data[index]["name"] === author) {
          if (data[index]["line"] === saying) {
            setTimeout(function() {
              $(".loader-wrapper2").fadeOut();
            }, 1000);

            level += 1;
            this.pauseClock();
            if (level == 6) {
              $(".black-game-box").fadeOut();
              $("#congrats").fadeIn();
            }
            points = (level - 1) * 20;
            $(".one-liner").text(
              "YOU GOT IT RIGHT! YOU NOW HAVE " + points + " POINTS."
            );
            $(".next-lvl-btn").fadeIn();
            return true;
          } else {
            $(".loader-wrapper2").fadeOut();
            $(".lives").html("");

            if (lives > 0) {
              lives -= 1;

              if (lives == 0) {
                this.pauseClock();
                $(".black-game-box").fadeOut();
                points = (level - 1) * 20;
                $(".load-points").text(points);
                $("#out_of_lives").fadeIn();
              }

              for (let i = 0; i < lives; i++) {
                $(".lives").append("!");
              }
            } else $(".lives").html("");

            if (lives == 1) {
              var live_text = "ONE";
            } else if (lives == 2) {
              var live_text = "TWO";
            }
            $(".one-liner").html(
              "YOU GOT IT <span style='color: red;''>WRONG</span>! YOU HAVE <span style='color: red;'>" +
                live_text +
                " LIVES</span> LEFT."
            );
            setTimeout(function() {
              // $(".one-liner").html('"<span id="load-line"></span>"');
              $("#load-line").text(saying);
            }, 1500);
            return false;
          }
        }
      }
    },
    goToNextLevel: function() {
      $(".next-lvl-btn").fadeOut();
      _authors = _authors.filter(author => author.line !== saying);
      $(".load-persons").html("");
      $("#m-loader").show();
      $(this).hide();

      tempAuthorsObj = this.getAuthorObj();


      authorsObj = this.shuffle(tempAuthorsObj);

      let tempRandomNum = Math.floor(Math.random() * 4);


      randomAuthorObj = authorsObj[tempRandomNum];
      line = randomAuthorObj.line;

      let persons = authorsObj;
      let length = persons.length;
      for (let i = 0; i < length; i++) {
        let childEle = `
					<div class='col-md-3 s-box img_block_wrapper'>
						<div class='img_block ${persons[i].image.split(".")[0]}'>${
          persons[i].name
        }</div>
						<div class='s-name authorName'>${persons[i].name}</div>
					</div>
				`;
        $(".load-persons").append(childEle);
      }

      $(".one-liner").html('"<span id="load-line"></span>"');
      $("#load-line").text(line);
      $("#m-loader").hide();

      this.pauseClock();
      this.restartClock();
      this.startClock();
    }
  },
  beforeCreate: function () {
    $('body').addClass('eureka');
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('eureka');
    next();
  },
};
